import {AfterViewInit, Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef, Input} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {MatStepper, MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import Swal from 'sweetalert2';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {CommonModule} from '@angular/common';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {MatTooltipModule} from '@angular/material/tooltip';

import {DomSanitizer,} from '@angular/platform-browser';
import {HeaderComponent} from '../../header/header.component';
import {FooterComponent} from '../../footer/footer.component';
import {NumericDirective} from '../../../validaciones/directives/numeric.directive';
import {AlphanumericDirective} from '../../../validaciones/directives/alphanumeric.directive';
import {PlacaDirective} from '../../../validaciones/directives/placa.directive';
import {MatIconModule} from '@angular/material/icon';
import {
  catchError, distinctUntilChanged,
  filter, fromEvent, map, merge,
  of,
  Subject,
  switchMap,
  takeUntil,
  tap
} from 'rxjs';
import {validadorReutilizable} from '../../../shared/utils/validadores';
import {ConsultarEstatusVehiculoMoralService} from '../../../service/consultarEstatusVehiculoMoral.service';
import {SolicitarCertificadoEstatalMoralService} from '../../../service/solicitarCertificadoEstatalMoral.service';
import {EstatusVehiculoResponseMoral} from '../../../pojos/estatusVehiculoResponseMorales';
import {TrimOnBlurDirective} from '../../../validaciones/directives/trim-on-blur.directive';
import {CatEfectoCertificado} from '../../../service/catEfectoCertificado.service';
import {CatCoberturaCertificados} from '../../../service/catCoberturaCertificados.service';
import {SolicitudVo} from '../../../pojos/solicitudVo';
import {
  ConfirmarInformacionPropietarioMoralService
} from '../../../service/ConfirmarInformacionPropietarioMoral.service'
import {PayloadMoralEstatal} from '../../../pojos/PayloadMoralEstatal'
//import { EstatusVehiculoResponse } from '../../../pojos/estatusVehiculoResponse';
import {ImprimirSolicitudCdniGenerico} from '../../../service/imprimirSolicitudCdniGenerico.service';
import {DocumentoService} from '../../../service/cargarDocumentos.service';
import {HttpEventType, HttpEvent} from '@angular/common/http';
import {EliminarDocumentos} from '../../../service/eliminarDocumentos.service';
import {NameDirective} from '../../../validaciones/directives/name.directive';
import {lettersDirective} from '../../../validaciones/directives/lettersDirective.directive';
import {Router} from '@angular/router';

@Component({
  selector: 'app-persona-moral-estatal',
  imports: [
    ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatOptionModule,
    HeaderComponent,
    FooterComponent,
    MatCheckboxModule,
    FormsModule,
    CommonModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,

    NumericDirective,
    AlphanumericDirective,
    PlacaDirective,
    TrimOnBlurDirective,
    NameDirective,
    lettersDirective,
  ],
  templateUrl: './persona-moral-estatal.component.html',
  styleUrl: './persona-moral-estatal.component.css',
  standalone: true
})
export class PersonaMoralEstatalComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('rfcMoralInput', {static: false}) rfcMoralInput!: ElementRef;
  @ViewChild('fechaConstitucionInput', {static: false}) fechaConstitucionInput!: ElementRef;
  @ViewChild('sexoInput', {static: false}) sexoInput!: ElementRef;
  @ViewChild('fechaNacimientoInput', {static: false}) fechaNacimientoInput!: ElementRef;


  @ViewChild('categoriaInput', {static: false}) categoriaInput!: ElementRef;
  @ViewChild('marcaInput', {static: false}) marcaInput!: ElementRef;
  @ViewChild('submarcaInput', {static: false}) submarcaInput!: ElementRef;
  @ViewChild('modeloInput', {static: false}) modeloInput!: ElementRef;
  @ViewChild('motorInput', {static: false}) motorInput!: ElementRef;
  @ViewChild('refrendoInput', {static: false}) refrendoInput!: ElementRef;
  @ViewChild('repuveInput', {static: false}) repuveInput!: ElementRef;


  private consultaExitosaRealizada = false;
  private rfcMoralIncompletoDelServicio: string | null = null;

  // Campos que siempre deben ser editables por el usuario o tienen lógica especial de habilitación
  readonly camposEditablesManualmente: string[] = [
    'rfc', // Representante legal
    'rfcMoral', // Empresa (lógica especial de habilitación)
    'curp', // Representante legal
    'niv',
    'placa',
    'motivo',
    'certificadoPor',
    'tipoServicio',
    'numeroTelefono',
    'correoElectronico',
    'nombre', // Representante legal
    'apellidoPaterno', // Representante legal
    'apellidoMaterno', // Representante legal
    'sexo', // Representante legal
    'fechaNacimiento', // Representante legal
    'homoclaveRepresentante' // Representante legal
  ];

  // Flags para el estado del RFC del Representante Legal (CuartoFormGroup)

  // Flag para el estado del RFC de la Persona Moral (SegundoGrupo)
  public rfcMoralCompletoDelServicio = false;

  //*****************Variables para grupos stepper******************
  PrimerFormGroup!: FormGroup;
  SegundoGrupo!: FormGroup;
  TercerFormGroup!: FormGroup;
  CuartoFormGroup!: FormGroup;
  QuintoFormGroup!: FormGroup;
  SextoFormGroup!: FormGroup;
  SeptimoFormGroup!: FormGroup;
  //*****************Terminan variables para grupos stepper******************

  mostrarSpinner = false;
  isLinear = false;

  /****************variables para uso de cronometro de boton para descargar documentos***************/

  @Input() efectosCertificados: any[] = [];
  @Input() coberturaCertificados: any[] = [];
  @Input() solicitudVo!: SolicitudVo;

  isUploading: { [key: string]: boolean } = {};
  uploadProgress: { [key: string]: number } = {};

  private destroy$ = new Subject<void>();

  constructor(
    private _formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private vehiculoService: ConsultarEstatusVehiculoMoralService,
    private solicitudService: SolicitarCertificadoEstatalMoralService,
    private elementRef: ElementRef,
    private cd: ChangeDetectorRef,
    private catEfectoCertificadoService: CatEfectoCertificado,
    private catCoberturaCertificadoService: CatCoberturaCertificados,
    private confirmarRfcMoralService: ConfirmarInformacionPropietarioMoralService,
    private imprimirSolicitudService: ImprimirSolicitudCdniGenerico,
    private documentoService: DocumentoService,
    private eliminarDocumentoService: EliminarDocumentos,
    private router: Router
  ) {
    this.solicitudVo = new SolicitudVo();
    this.catCoberturaCertificados();
    this.catEfectoCertificado();
  }

  ngOnInit(): void {
    this.PrimerFormGroup = this._formBuilder.group({
      niv: ['', [Validators.required, validadorReutilizable({
        blnPermitirLetras: true,
        blnPermitirNumeros: true,
        intLongitudMinima: 6,
        intLongitudMaxima: 17
      })]],
      placa: ['', [Validators.required, validadorReutilizable({
        blnPermitirLetras: true,
        blnPermitirNumeros: true,
        blnPermitirGuionMedio: true,
        intLongitudMinima: 6,
        intLongitudMaxima: 10
      })]],
      motivo: ['', Validators.required],
      certificadoPor: ['', Validators.required],
      tipoServicio: ['', Validators.required],
      // Campos que se llenarán desde el servicio o serán editables/obligatorios si no vienen
      categoria: ['', Validators.required],
      marca: ['', Validators.required],
      submarca: ['', Validators.required],
      modelo: ['', Validators.required],
      motor: ['', Validators.required],
      refrendo: [''//, Validators.required
      ],
      repuve: ['', Validators.required],
    });

    this.SegundoGrupo = this._formBuilder.group({
      rfcMoral: ['', [Validators.required, Validators.pattern(/^[A-ZÑ&]{3}[0-9]{6}[A-Z0-9]{3}$/i),
        validadorReutilizable({
          blnPermitirLetras: true,
          blnPermitirNumeros: true,
          intLongitudMinima: 12,
          intLongitudMaxima: 12
        })]],
      // Campos que se llenarán desde el servicio o serán editables/obligatorios si no vienen
      fechaConstitucion: ['', Validators.required],
      razonSocial: ['', Validators.required],
      calle: ['', Validators.required],
      numExterior: ['',],
      numInterior: [''], // No Interior puede ser opcional
      codigoPostal: ['', Validators.required],
      estado: ['', Validators.required],
      municipio: ['', Validators.required],
      localidad: ['', Validators.required],
    });

    this.TercerFormGroup = this._formBuilder.group({
      numeroTelefono: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      correoElectronico: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
    });

    this.CuartoFormGroup = this._formBuilder.group({
      // Patrón corregido para 13 dígitos (Letras, Números y Homoclave de 3)
      rfc: ['', [Validators.required, Validators.pattern(/^[A-ZÑ&]{4}\d{6}[A-Z\d]{3}$/i)]],
      // El campo homoclaveRepresentante ha sido ELIMINADO
      curp: ['', [Validators.required,
        Validators.minLength(18), Validators.maxLength(18), Validators.pattern(/^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/)]],
      nombre: ['', [
        Validators.required,
        validadorReutilizable({
          blnPermitirLetras: true,
          blnPermitirEspacios: true,
          blnPermitirPuntos: true,
          blnPermitirAcentos: true,


        })
      ]],
      apellidoPaterno: ['', [
        Validators.required,
        validadorReutilizable({
          blnPermitirLetras: true,
          blnPermitirEspacios: true,
          blnPermitirPuntos: true,
          blnPermitirAcentos: true,


        })
      ]],
      apellidoMaterno: ['', [
        Validators.required,
        validadorReutilizable({
          blnPermitirLetras: true,
          blnPermitirEspacios: true,
          blnPermitirPuntos: true,
          blnPermitirAcentos: true,

        })
      ]],
      sexo: ['', Validators.required],
      fechaNacimiento: ['', Validators.required],
    });

    this.QuintoFormGroup = this._formBuilder.group({
      documentos: [false, Validators.requiredTrue],
    });

    this.SextoFormGroup = this._formBuilder.group({
      actaConstitutiva: ['', Validators.required],
      factura: ['', Validators.required],
      ine: ['', Validators.required],
      poderNotarial: ['', Validators.required],
      repuveDoc: ['', Validators.required], // Cambiado de 'repuve' para evitar colisión con el del PrimerFormGroup
      solicitud: ['', Validators.required],
    });

    this.SeptimoFormGroup = this._formBuilder.group({
      terminosCondiciones: [false, Validators.requiredTrue],
    });

    this.inicializarValidacionesReactivas();
  }

  ngAfterViewInit() {
    this.aplicarEstilosDeshabilitado(this.categoriaInput);
    this.aplicarEstilosDeshabilitado(this.marcaInput);
    this.aplicarEstilosDeshabilitado(this.submarcaInput);
    this.aplicarEstilosDeshabilitado(this.modeloInput);
    this.aplicarEstilosDeshabilitado(this.motorInput);
    this.aplicarEstilosDeshabilitado(this.refrendoInput);
    this.aplicarEstilosDeshabilitado(this.repuveInput);

    const nivControl = this.PrimerFormGroup.get('niv');
    const placaControl = this.PrimerFormGroup.get('placa');

    this.aplicarEstilosDeshabilitado(this.sexoInput);

    if (nivControl && placaControl) {
      const nivField = this.elementRef.nativeElement.querySelector('#nivField');
      const placaField = this.elementRef.nativeElement.querySelector('#placaField');

      merge(fromEvent(nivField, 'blur'), fromEvent(placaField, 'blur')).pipe(
        filter(() => nivControl.valid && placaControl.valid && (nivControl.dirty || placaControl.dirty)), // Consultar solo si hay cambios y son válidos
        map(() => [nivControl.value, placaControl.value]),
        tap(() => this.mostrarSpinner = true),
        switchMap(([niv, placa]) => this.consultarVehiculo(niv, placa)),
        takeUntil(this.destroy$)
      ).subscribe({
        next: (respuesta) => {
          this.procesarRespuesta(respuesta);
          if (respuesta && respuesta.intCodigoHttp === 200) { // Asumiendo 200 es éxito total o parcial
            this.consultaExitosaRealizada = true;

            this.actualizarEstilosCampo('niv', nivControl);
            this.actualizarEstilosCampo('placa', placaControl);
          } else {
            this.consultaExitosaRealizada = false;
          }
          this.cd.detectChanges();
        },
        error: (error) => {
          this.mostrarSpinner = false;
          this.consultaExitosaRealizada = false;
        }
      });

      merge(nivControl.valueChanges, placaControl.valueChanges).pipe(
        filter(() => this.consultaExitosaRealizada && (nivControl.invalid || placaControl.invalid)),
        takeUntil(this.destroy$)
      ).subscribe(() => {
        this.resetearCamposServicio(); // Solo resetea campos que vienen del servicio
        this.consultaExitosaRealizada = false;
      });
    }
    // ========== INICIA CÓDIGO PARA VALIDACIÓN DE RFC MORAL ==========
    const rfcMoralControl = this.SegundoGrupo.get('rfcMoral');
    if (rfcMoralControl) {
      const rfcMoralField = this.elementRef.nativeElement.querySelector('[formControlName="rfcMoral"]');

      fromEvent(rfcMoralField, 'blur').pipe(
        // 1. Ejecutar solo si el campo está habilitado y es válido según las validaciones locales (pattern, required)
        filter(() => !rfcMoralControl.disabled && rfcMoralControl.valid),

        // 2. IMPORTANTE: Continuar solo si previamente guardamos un RFC incompleto del servicio.
        filter(() => !!this.rfcMoralIncompletoDelServicio),

        map(() => rfcMoralControl.value),
        distinctUntilChanged(),
        tap(() => this.mostrarSpinner = true),

        // 3. Llamar al servicio CORRECTO con AMBOS parámetros
        switchMap(rfcIngresado =>
          this.confirmarRfcMoralService.confirmar(rfcIngresado, this.rfcMoralIncompletoDelServicio!).pipe(
            catchError(error => {
              this.mostrarSpinner = false;
              // Usamos la propiedad `userMessage` del error, como define el servicio.
              const message = error.userMessage || 'Error de comunicación al validar el RFC.';
              //  Swal.fire('Error de Servicio', message, 'error');
              Swal.fire({
                html: ('Error de Servicio ' + message + ' error'),
                icon: 'warning',
                confirmButtonColor: '#A11A5C',
                confirmButtonText: 'Confirmar',
              });

              rfcMoralControl.setErrors({'serviceError': true});
              this.actualizarEstilosCampo('rfcMoral', rfcMoralControl);
              return of(null);
            })
          )
        ),
        filter(respuesta => respuesta !== null),
        takeUntil(this.destroy$)
      ).subscribe(respuesta => {
        this.mostrarSpinner = false;

        Swal.fire({
          title: 'Verificación de RFC',
          html: respuesta.strMensaje,
          icon: respuesta.intCodigoHttp === 200 ? 'success' : 'warning',
          confirmButtonColor: '#A11A5C',
          confirmButtonText: 'Confirmar',
        });

        if (respuesta.intCodigoHttp !== 200) {
          rfcMoralControl.setErrors({'respuesta no Valida': true});
        } else {

          this.aplicarEstilosDeshabilitado(this.rfcMoralInput);
          this.rfcMoralIncompletoDelServicio = null;
          const fechaInferida = inferirFechaConstitucion(rfcMoralControl.value);
          if (fechaInferida) {
            this.SegundoGrupo.get('fechaConstitucion')?.setValue(fechaInferida);
            this.aplicarEstilosDeshabilitado(this.fechaConstitucionInput);

          }
        }

        this.actualizarEstilosCampo('rfcMoral', rfcMoralControl);
      });
    }
    // ========== TERMINA CÓDIGO PARA VALIDACIÓN DE RFC MORAL ==========
    // ========== INICIA CÓDIGO PARA INFERIR DATOS DESDE CURP ==========
    const curpControl = this.CuartoFormGroup.get('curp');
    if (curpControl) {
      const curpField = this.elementRef.nativeElement.querySelector('[formControlName="curp"]');

      // Escuchar el evento 'blur' del campo CURP
      fromEvent(curpField, 'blur').pipe(
        filter(() => curpControl.valid && curpControl.value.length === 18), // Continuar solo si la CURP es válida y completa
        map(() => curpControl.value),
        // distinctUntilChanged(), // Evitar ejecuciones si el valor no ha cambiado
        takeUntil(this.destroy$)
      ).subscribe(curp => {
        const datosInferidos = inferirDatosDesdeCurp(curp);

        const sexoControl = this.CuartoFormGroup.get('sexo');
        const fechaNacimientoControl = this.CuartoFormGroup.get('fechaNacimiento');

        if (datosInferidos && sexoControl && fechaNacimientoControl) {
          // Llenar los campos
          sexoControl.setValue(datosInferidos.sexo);
          fechaNacimientoControl.setValue(datosInferidos.fechaNacimiento);

          // Deshabilitar los campos y aplicar estilos
          /*          sexoControl.disable();
                    fechaNacimientoControl.disable();*/
          this.aplicarEstilosDeshabilitado(this.sexoInput);
          this.aplicarEstilosDeshabilitado(this.fechaNacimientoInput);
        }
      });

      // Lógica para resetear si el usuario modifica la CURP y la hace inválida
      curpControl.valueChanges.pipe(
        filter(() => curpControl.invalid),
        takeUntil(this.destroy$)
      ).subscribe(() => {
        const sexoControl = this.CuartoFormGroup.get('sexo');
        const fechaNacimientoControl = this.CuartoFormGroup.get('fechaNacimiento');

        if (curpControl.invalid) {
          sexoControl?.reset('');
          fechaNacimientoControl?.reset('');
          this.aplicarEstilosDeshabilitado(this.sexoInput);
          this.aplicarEstilosDeshabilitado(this.fechaNacimientoInput);
        }
      });
    }
    // ========== TERMINA CÓDIGO PARA INFERIR DATOS DESDE CURP ==========

  }

  onChangeTipoServicio(event: any) {
    this.solicitudVo.strTipoServicio = event.target.value;
    
  }

  // Resetea solo los campos que se llenan desde el servicio, excepto NIV y PLACA
  resetearCamposServicio() {
    const camposServicioPrimerGrupo = ['categoria', 'marca', 'submarca', 'modelo', 'motor', 'refrendo', 'repuve', 'motivo', 'certificadoPor', 'tipoServicio'];
    const camposServicioSegundoGrupo = ['fechaConstitucion', 'razonSocial', 'calle', /*'numExterior',*/ 'numInterior', 'codigoPostal', 'estado', 'municipio', 'localidad', 'rfcMoral'];

    camposServicioPrimerGrupo.forEach(nombre => {
      const control = this.PrimerFormGroup.get(nombre);
      if (control) {
        control.setValue('');
        control.enable();
        control.markAsPristine()
      }
    });

    camposServicioSegundoGrupo.forEach(nombre => {
      const control = this.SegundoGrupo.get(nombre);
      if (control) {
        control.reset('');
        control.enable();
        if (nombre === 'rfcMoral') {
          this.rfcMoralCompletoDelServicio = false;
        }
      }
    });

    // Opcional pero recomendado: forzar una actualización de la validación a nivel de grupo.
    this.PrimerFormGroup.updateValueAndValidity();
    this.SegundoGrupo.updateValueAndValidity();
  }

  //********************************************* VALIDACIONES REACTIVAS (SIN CAMBIOS) ************************************************//

  get todosLosFormGroups(): FormGroup[] {
    return [
      this.PrimerFormGroup, this.SegundoGrupo, this.TercerFormGroup,
      this.CuartoFormGroup, this.QuintoFormGroup, this.SextoFormGroup, this.SeptimoFormGroup
    ];
  }

  private inicializarValidacionesReactivas(): void {
    this.todosLosFormGroups.forEach(formGroup => {
      if (!formGroup || !(formGroup instanceof FormGroup)) return;
      Object.keys(formGroup.controls).forEach(campo => {
        // if (this.camposIgnoradosValidacionReactiva.includes(campo)) return;

        const control = formGroup.get(campo);
        if (control) {
          control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.actualizarEstilosCampo(campo, control);
          });
        }
      });
    });
  }

  private actualizarEstilosCampo(campo: string, control: AbstractControl): void {
    const fieldElement = document.querySelector(`[formControlName="${campo}"]`);
    if (fieldElement) {
      // La condición ahora incluye una excepción para tus campos específicos
      if ((control.touched || control.dirty) ||
        ((campo === 'rfcMoral' || campo === 'fechaConstitucion' || campo === 'sexo' || campo === 'fechaNacimiento'
          || campo === 'estado' || campo === 'municipio') && control.valid)) {
        if (control.valid) {
          fieldElement.classList.remove('is-invalid');
          fieldElement.classList.add('is-valid');
        } else {
          fieldElement.classList.add('is-invalid');
          fieldElement.classList.remove('is-valid');
        }
      } else {
        // Si no ha interactuado y no es una de las excepciones, quitamos las clases
        fieldElement.classList.remove('is-valid', 'is-invalid');
      }
    }
  }

  //********************************************* STEPPER Y MENSAJES DE ERROR ************************************************//
  validarYContinuar(campos: { grupo: FormGroup; nombres: string[] }) {
    let primerCampoInvalido: string | null = null;

    for (const campo of campos.nombres) {
      const control = campos.grupo.get(campo);

      if (!control || control.disabled) {          // ⬅️  Salta controles inexistentes o deshabilitados
        continue;
      }

      // 1️⃣  Solo márcalo como tocado si REALMENTE está inválido
      if (control.invalid) {
        control.markAsTouched();
        if (!primerCampoInvalido) primerCampoInvalido = campo;
      }

      // 2️⃣  Actualiza estilos (quita / pone is‑invalid)
      this.actualizarEstilosCampo(campo, control);
    }

    if (!primerCampoInvalido) {
      this.stepper.next();
    } else {
      Swal.fire({
        html: this.mensajeError(primerCampoInvalido),
        icon: 'warning',
        confirmButtonColor: '#A11A5C',
        confirmButtonText: 'Confirmar',
      });
      // Opcional: Foco en el primer campo inválido
      const fieldElement = document.querySelector(`[formControlName="${primerCampoInvalido}"]`) as HTMLElement;
      fieldElement?.focus();
    }
  }

  mensajeError(campo: string): string {
    const control = this.todosLosFormGroups.reduce((acc, fg) => acc || fg.get(campo), null as AbstractControl | null);
    if (control && control.errors) {
      if (control.errors['required']) {
        // Mensajes genéricos para 'required' pueden ser suficientes si los nombres de campo son claros
      }
      // Podrías añadir más lógica para errores específicos como pattern, minlength, etc.
    }


    const mensajes: any = {
      //seccion 1
      niv: 'El campo <b> NIV de los Datos del Vehículo </b> no debe estar vacío.',
      placa:
        'El campo <b> Placa de los Datos del Vehículo </b> no debe estar vacío.',
      motivo:
        'El campo <b> Motivo de Solicitud de los Datos del Vehículo </b> debe estar seleccionado.',
      certificadoPor:
        'El campo <b> Certificado Por.. de los Datos del Vehículo </b> debe estar seleccionado.',
      tipoServicio:
        'El campo <b> Tipo Servicio de los Datos del Vehículo </b> debe estar seleccionado.',
      categoria:
        'El campo <b> Categoria de los Datos del Vehículo </b> no debe estar vacío.',
      marca:
        'El campo <b> Marca de los Datos del Vehículo </b> no debe estar vacío.',
      submarca:
        'El campo <b> Submarca de los Datos del Vehículo </b> no debe estar vacío.',
      modelo:
        'El campo <b> Modelo de los Datos del Vehículo </b> no debe estar vacío.',
      motor:
        'El campo <b> Motor de los Datos del Vehículo </b> no debe estar vacío.',
      refrendo:
        'El campo <b> Refrendo de los Datos del Vehículo </b> no debe estar vacío.',
      repuve:
        'El campo <b> repuve de los Datos del Vehículo </b> no debe estar vacío.',

      //seccion 2
      rfcMoral:
        'Por favor verifica que el campo <b> RFC </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLL000000AAA',
      fechaConstitucion:
        'El campo <b> Fecha constitucion de los Datos de la empresa </b> no debe estar vacío.',
      razonSocial:
        'El campo <b> Razon social de los Datos de la empresa </b> no debe estar vacío.',

      //seccion 3
      calle:
        'El campo <b> Calle del Domicilio Fiscal </b> no debe estar vacío.',
      numExterior:
        'El campo <b> Numero Exterior del Domicilio Fiscal </b> no debe estar vacío.',
      codigoPostal:
        'El campo <b> Codigo Postal del Domicilio Fiscal </b> no debe estar vacío.',
      estado:
        'El campo <b> Estado del Domicilio Fiscal </b> debe estar seleccionado.',
      municipio:
        'El campo <b> Municipio del Domicilio Fiscal </b> debe estar seleccionado.',
      localidad:
        'El campo <b> Localidad del Domicilio Fiscal </b> debe estar seleccionado.',

      //seccion 4
      correoElectronico:
        'Por favor verifica que el campo <b> Correo Electrónico de los Medios de Contacto</b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato correo: </b> nombre@ejemplo.com',
      numeroTelefono:
        'El campo <b> Número Teléfono de los Medios de Contacto  </b> debe contener 10 números.',

      //seccion 5
      rfc:
        'Por favor verifica que el campo <b> RFC </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLLL000000AAA',
      curp:
        'Por favor verifica que el campo <b> CURP </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLLL000000LLLLLLA0',
      nombre:
        'El campo <b> Nombre de los Datos del Representante Legal </b> no debe estar vacío.',
      apellidoPaterno:
        'El campo <b> Apellido Paterno de los Datos del Representante Legal </b> no debe estar vacío.',
      apellidoMaterno:
        'El campo <b> Apellido Materno de los Datos del Representante Legal </b> no debe estar vacío.',
      sexo:
        'El campo <b> Sexo de los Datos del Representante Legal </b> no debe estar vacío.',
      fechaNacimiento:
        'El campo <b> Fecha Nacimiento de los Datos del Representante Legal </b> no debe estar vacío.',

      //seccion 6
      documentos:
        'Para continuar a la sección de <b>Documentos</b> primero debes marcar el cuadro que aparece en la parte inferior de esta sección',
      actaConstitutiva:
        'El documento <b>Acta Constitutiva</b> no se ha seleccionado.',
      factura: 'El documento <b>Factura</b> no se ha seleccionado.',
      ine: 'El documento <b>INE REPRESENTANTE LEGAL</b> no se ha seleccionado.',
      poderNotarial:
        'El documento <b>Poder Notarial</b> no se ha seleccionado.',
      repuveDoc: 'El documento <b>REPUVE</b> no se ha seleccionado.',
      solicitud: 'El documento <b>Solicitud</b> no se ha seleccionado.',
      tenencia: 'El documento <b>Tenencia</b> no se ha seleccionado.',
    };
    return mensajes[campo] || `El campo ${campo.replace(/([A-Z])/g, ' $1').toLowerCase()} es no valido o está incompleto.`;
  }


  llenarCamposVehiculo(data: any): void {

    try {
      if (!data || typeof data !== 'object') {

        this.resetearCamposServicio(); // Resetea campos que pudieron venir del servicio
        return;
      }

      const rfcMoralServicio = data.rfcMoral;
      const fechaConstitucionServicio = data.fechaConstitucion;

      const rfcMoralControl = this.SegundoGrupo.get('rfcMoral');
      const fechaConstitucionControl = this.SegundoGrupo.get('fechaConstitucion');

      // 1. Lógica para el RFC Moral
      if (rfcMoralControl) {
        if (rfcMoralServicio && rfcMoralServicio.length === 12) {
          rfcMoralControl.setValue(rfcMoralServicio);
          this.aplicarEstilosDeshabilitado(this.rfcMoralInput);
          this.rfcMoralCompletoDelServicio = true;
        } else {
          rfcMoralControl.reset(rfcMoralServicio || ''); // Dejamos el valor incompleto si existe
          this.removerEstilosDeshabilitado(this.rfcMoralInput);
          this.rfcMoralCompletoDelServicio = false;
        }
        rfcMoralControl.markAsTouched();

      }

      // 2. Lógica para la Fecha de Constitución (depende del RFC y de su propio valor)
      if (fechaConstitucionControl) {
        const rfcEstaCompleto = rfcMoralServicio && rfcMoralServicio.length === 12;
        // Consideramos "vacío" si es null, undefined o un string vacío.
        const fechaServicioEstaVacia = fechaConstitucionServicio === null || fechaConstitucionServicio === undefined || fechaConstitucionServicio === '';

        // CASO 1: La fecha del servicio está vacía PERO el RFC está completo -> INFERIR FECHA
        if (fechaServicioEstaVacia && rfcEstaCompleto) {
          const fechaInferida = inferirFechaConstitucion(rfcMoralServicio);
          fechaConstitucionControl.setValue(fechaInferida);
          this.aplicarEstilosDeshabilitado(this.fechaConstitucionInput);
        }
        // CASO 2: La fecha del servicio SÍ tiene un valor -> USAR VALOR DEL SERVICIO
        else if (!fechaServicioEstaVacia) {
          fechaConstitucionControl.setValue(fechaConstitucionServicio);
          this.aplicarEstilosDeshabilitado(this.fechaConstitucionInput);
        }
        // CASO 3: Ambos están vacíos/incompletos -> DEJAR VACÍO Y HABILITADO
        else {
          fechaConstitucionControl.reset('');
          this.removerEstilosDeshabilitado(this.fechaConstitucionInput);
        }
        fechaConstitucionControl.markAsTouched();
      }

      // --- Llenado de otros campos (Primer y Segundo Grupo desde el servicio) ---
      Object.keys(data).forEach(nombreCampo => {
        if (nombreCampo === 'rfcMoral' || nombreCampo === 'fechaConstitucion') {
          return;
        }
        const controlEncontrado = this.PrimerFormGroup.get(nombreCampo) || this.SegundoGrupo.get(nombreCampo);

        if (controlEncontrado) {
          // 1. Definimos claramente qué es un valor "vacío"
          const valorServicio = data[nombreCampo];
          const esValorVacio = valorServicio === null || valorServicio === undefined ||
            (typeof valorServicio === 'string' && valorServicio.trim() === '');

          // 2. Asignamos el valor al control. Si es vacío, asignamos '', si no, el valor del servicio.
          controlEncontrado.setValue(esValorVacio ? '' : valorServicio, {emitEvent: false});
          controlEncontrado.markAsTouched();
          controlEncontrado.updateValueAndValidity();
          // 3. Lógica explícita para habilitar o deshabilitar
          if (esValorVacio) {
            // Si el valor del servicio es vacío, SIEMPRE habilitamos el campo para entrada manual.

            controlEncontrado.disable({emitEvent: false});
          } else {
            // Si el servicio trae un valor REAL, decidimos si el campo se debe deshabilitar.
            // Se deshabilita si NO está en la lista de campos que el usuario siempre puede editar.
            if (this.camposEditablesManualmente.includes(nombreCampo)) {

              controlEncontrado.enable({emitEvent: false});
            } else {
              controlEncontrado.disable({emitEvent: false});
            }
          }

          // 4. Actualizamos el estado del control (esto no cambia)
          controlEncontrado.updateValueAndValidity({emitEvent: false});
        }
      });

      // Los campos del CuartoFormGroup (Representante Legal) son de entrada manual y no se llenan desde esta 'data'.
      // La lógica para rfcReprecentanteServiceParcial/Completo se activa por la entrada del usuario en ese paso.

    } catch (error) {
      this.resetearCamposServicio();
    }
  }

  aplicarEstilosDeshabilitado(elemento: ElementRef): void {
    if (elemento && elemento.nativeElement) {
      const el = elemento.nativeElement;
      el.style.pointerEvents = 'none';
      el.style.opacity = '0.7';
      el.style.backgroundColor = '#f5f5f5';
      el.setAttribute('aria-disabled', 'true');
      el.tabIndex = -1;
    }
  }

  removerEstilosDeshabilitado(elemento: ElementRef): void {
    if (elemento && elemento.nativeElement) {
      const el = elemento.nativeElement;
      el.style.pointerEvents = 'auto';
      el.style.opacity = '1';
      el.style.backgroundColor = 'white';
      el.removeAttribute('aria-disabled');
      el.tabIndex = 0;
    }
  }

  // Este método resetea TODOS los campos de los formularios a su estado inicial,
  // Se llama cuando, por ejemplo, el usuario quiere empezar de nuevo o hay un error de consulta de informacion de niv y placa.
  resetearFormularios(): void {
    const camposServicioPrimerGrupo = ['niv', 'placa', 'motivo', 'certificadoPor', 'tipoServicio',];
    const camposServicioSegundoGrupo = ['fechaConstitucion', 'razonSocial', 'calle', 'numExterior', 'numInterior', 'codigoPostal', 'estado', 'municipio', 'localidad', 'rfcMoral'];

    camposServicioPrimerGrupo.forEach(nombre => {
      const control = this.PrimerFormGroup.get(nombre);
      if (control) {
        control.reset('');

      }
    });

    camposServicioSegundoGrupo.forEach(nombre => {
      const control = this.SegundoGrupo.get(nombre);
      if (control) {
        control.reset('');
        control.enable();
        if (nombre === 'rfcMoral') {
          this.rfcMoralCompletoDelServicio = false;
        }
      }
    });

    // Opcional pero recomendado: forzar una actualización de la validación a nivel de grupo.
    this.PrimerFormGroup.updateValueAndValidity();
    this.SegundoGrupo.updateValueAndValidity();
  }


  private consultarVehiculo(niv: string, placa: string) {
    this.resetearCamposServicio();
    return this.vehiculoService.consultarEstatusVehiculo(niv, placa).pipe(
      catchError(error => {
        this.mostrarErrorConsulta(error); // Cambiado para diferenciar de otros errores
        this.resetearFormularios();
        return of(null); // Devuelve un observable nulo para que el flujo continúe
      })
    );
  }

  private mostrarErrorConsulta(error: any): void {
    this.mostrarSpinner = false;
    const message = error.error?.strMensaje || // Ajustar si la estructura del error del backend es diferente
      error.originalError.message || // Si el servicio ya preparó un userMessage
      'Error al consultar el vehículo. Verifique los datos e inténtelo de nuevo.';
    this.showAlert("Error:", message, "error")
    // this.resetearCamposServicio(); // Limpiar campos que pudieron haberse llenado parcialmente
    this.resetearFormularios();
    this.consultaExitosaRealizada = false;
  }

  private procesarRespuesta(respuesta: null | EstatusVehiculoResponseMoral): void {
    this.mostrarSpinner = false;

    if (!respuesta) { // Puede ser null si catchError devolvió of(null)
      // El error ya se mostró en mostrarErrorConsulta
      this.resetearCamposServicio();
      this.consultaExitosaRealizada = false;
      return;
    }

    //if (!respuesta.vehiculoErrorResponseVo || !respuesta.vehiculoErrorResponseVo.strMensaje || respuesta.intCodigoHttp === undefined) {
    if (respuesta.intCodigoHttp !== 200) {
      const message = respuesta.vehiculoErrorResponseVo.strMensaje || // Ajustar si la estructura del error del backend es diferente
        respuesta.strMensaje ||
        'Error al consultar el vehículo. Verifique los datos e inténtelo de nuevo.';

      this.showAlert("Advertencia", message + `<br><br>Si tienes dudas, asiste a tu oficina recaudadora más cercana.`, "warning")

      this.resetearFormularios();
      this.consultaExitosaRealizada = false;
      return;
    }
    const mensajeServicio = respuesta.vehiculoErrorResponseVo?.strMensaje?.toLowerCase() ?? respuesta.strMensaje;


    if (respuesta.intCodigoHttp === 200) {

      // Asumimos que 200 significa que se obtuvieron datos, aunque el mensaje pueda tener alertas.
      // Si el mensaje indica un problema grave (ej. "vehículo no encontrado"), aunque sea 200, tratar como alerta.
      if (mensajeServicio.includes("no encontrado") || mensajeServicio.includes("no existe") || mensajeServicio.includes("SMyT")) {
        this.showAlert("Información del Vehículo", mensajeServicio.toLowerCase(), 'warning');
        this.resetearCamposServicio();
        this.consultaExitosaRealizada = false; // Permitir reintentar ya que no se cargaron datos
      } else {
        const datosFormateados = transformarRespuestaVehiculo(respuesta);
        this.llenarCamposVehiculo(datosFormateados);
        this.consultaExitosaRealizada = true;
        if (mensajeServicio !== "consulta correcta" && !mensajeServicio.includes("ok")) { // Mostrar mensaje si no es el genérico de éxito
          this.showAlert("Aviso del Vehículo", mensajeServicio, 'info');
        }
      }
    } else {
      // Códigos HTTP diferentes de 200 son errores o alertas significativas del backend
      this.showAlert("Error del Servicio", mensajeServicio, 'error');
      this.resetearCamposServicio();
      this.consultaExitosaRealizada = false; // Hubo un error, permitir reintentar
    }
  }

  private showAlert(titulo: string, texto: string, icono: 'error' | 'warning' | 'info' | 'success') {
    Swal.fire({
      title: titulo,
      html: texto,
      icon: icono,
      confirmButtonColor: '#04B404',
      confirmButtonText: 'Confirmar',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false
    });
  }


  //********************************************* BOTONES SIGUIENTE (AJUSTAR NOMBRES DE CAMPO SI ES NECESARIO) ************************************************//

  nextButtonClick() {
    this.validarYContinuar({
      grupo: this.PrimerFormGroup,
      nombres: ['niv', 'placa', 'motivo', 'certificadoPor', 'tipoServicio',
        /*'categoria', 'marca', 'submarca', 'modelo', 'motor', 'repuve'*/
      ],
    });
  }

  nextButtonClick2() {

    this.validarYContinuar({
      grupo: this.SegundoGrupo,
      nombres: ['rfcMoral', 'fechaConstitucion', 'razonSocial', 'calle', 'numExterior', 'codigoPostal', 'estado', 'municipio', 'localidad'],
    });
  }

  nextButtonClick3() {
    this.validarYContinuar({
      grupo: this.TercerFormGroup,
      nombres: ['numeroTelefono', 'correoElectronico'],
    });
  }

  nextButtonClick4() {
    this.validarYContinuar({
      grupo: this.CuartoFormGroup,
      nombres: ['rfc', 'curp', 'nombre', 'apellidoPaterno', 'apellidoMaterno', 'sexo', 'fechaNacimiento'],
    });
  }

  nextButtonClick5() {
    this.validarYContinuar({
      grupo: this.QuintoFormGroup,
      nombres: ['documentos'],
    });
  }

  nextButtonClick6() {
    this.validarYContinuar({
      grupo: this.SextoFormGroup,
      nombres: [
        'actaConstitutiva', 'factura', 'ine', 'poderNotarial', 'repuveDoc', 'solicitud'
      ],
    });
  }

  nextButtonClick7() {
    // 1. --- VALIDACIÓN INICIAL ---
    // Se valida primero que los términos y condiciones estén aceptados.
    const terminosControl = this.SeptimoFormGroup.get('terminosCondiciones');
    terminosControl?.markAsTouched();
    this.actualizarEstilosCampo('terminosCondiciones', terminosControl!);

    if (this.SeptimoFormGroup.invalid) {
      Swal.fire({
        html: '<b>Debes Aceptar los Términos y Condiciones</b>',
        icon: 'warning',
        confirmButtonColor: '#A11A5C',
        confirmButtonText: 'Confirmar',
      });
      return; // Detiene si no se aceptan
    }

    // Se valida que todos los pasos anteriores del formulario sean válidos.
    for (const fg of [this.PrimerFormGroup, this.SegundoGrupo, this.TercerFormGroup, this.CuartoFormGroup, this.SextoFormGroup]) {
      if (fg.invalid) {
        Swal.fire({
          html: ('Formulario Incompleto, Por favor, revise los pasos anteriores. Hay campos obligatorios sin llenar o con errores.'),
          icon: 'error',
          confirmButtonColor: '#A11A5C',
          confirmButtonText: 'Confirmar',
        });
        return; // Detiene si algún paso es inválido
      }
    }

    // 2. --- PASO DE CONFIRMACIÓN ---
    // Si todas las validaciones pasan, se muestra la alerta de confirmación.
    Swal.fire({
      title: '¿Estás seguro que deseas guardar la información?',
      icon: 'question',
      confirmButtonColor: '#04B404',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      showCancelButton: true,
      allowOutsideClick: false,
    }).then((result) => {
      // 3. --- LÓGICA DE ENVÍO (SOLO SI SE CONFIRMA) ---
      if (result.isConfirmed) { // El usuario hizo clic en "Sí"
        this.mostrarSpinner = true;
        const correo = this.TercerFormGroup.get('correoElectronico')?.value;

        // Creación del objeto del payload con la estructura y datos correctos
        const datosParaBackend: PayloadMoralEstatal = {
          // --- PrimerFormGroup: Datos del Vehículo ---
          strNiv: this.PrimerFormGroup.get('niv')?.value || '',
          strPlaca: this.PrimerFormGroup.get('placa')?.value || '',
          intIdMotivoSolicitud: this.PrimerFormGroup.get('motivo')?.value || null,
          intIdCertificadoPor: this.PrimerFormGroup.get('certificadoPor')?.value || null,
          intIdTipoServicio: this.PrimerFormGroup.get('tipoServicio')?.value || null,
          intIdTipoTramite: 1, // Valor fijo: 1 para Estatal

          // --- SegundoGrupo: Datos de la Empresa y Domicilio Fiscal ---
          strRfcMoral: (this.SegundoGrupo.get('rfcMoral')?.value || '').toUpperCase(),
          strFechaConstitucion: this.SegundoGrupo.get('fechaConstitucion')?.value || '',

          // --- TercerFormGroup: Medios de Contacto ---
          strTelefono: this.TercerFormGroup.get('numeroTelefono')?.value || '',
          strEmail: this.TercerFormGroup.get('correoElectronico')?.value || '',

          // --- CuartoFormGroup: Datos del Representante Legal ---
          strRfcRepresentante: (this.CuartoFormGroup.get('rfc')?.value || '').toUpperCase(),
          strCurpRepresentante: (this.CuartoFormGroup.get('curp')?.value || '').toUpperCase(),
          strNombreRepresentante: this.CuartoFormGroup.get('nombre')?.value || '',
          strApPaternoRepresentante: this.CuartoFormGroup.get('apellidoPaterno')?.value || '',
          strApMaternoRepresentante: this.CuartoFormGroup.get('apellidoMaterno')?.value || '',
          strSexoRepresentante: this.CuartoFormGroup.get('sexo')?.value || '',
          strFechaNacimientoRepresentante: this.CuartoFormGroup.get('fechaNacimiento')?.value || '',
        };

        this.solicitudService.solicitarCertificdo(datosParaBackend).subscribe({
          next: (respuesta) => {
            this.mostrarSpinner = false;
            Swal.fire({
              icon: 'success',
              title: 'Solicitud Enviada Correctamente',
              html: `Su solicitud ha sido procesada. <br><br>
             Se ha enviado un correo electrónico a: <b style="color: #A11A5C">${correo}</b> con los siguientes pasos.
             <hr>Le recomendamos revisar su bandeja de entrada y la carpeta de spam.`,
              confirmButtonColor: '#04B404',
              confirmButtonText: 'Confirmar',
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                this.resetearFormularios();
                this.router.navigate(['https://tlaxcallan.sefintlax.gob.mx/tlaxcallan']);
              }
            });
          },
          error: (error) => {
            this.mostrarSpinner = false;
            const backendMessage = error.error?.message || error.error?.strMensaje || error.message;
            Swal.fire('Error al Enviar', 'Hubo un problema al enviar la solicitud: ' + (backendMessage || 'Error desconocido. Intente más tarde.'), 'error');
          }
        });
      } else {
        // El usuario hizo clic en "No", no hacemos nada.
        this.mostrarSpinner = false;
      }
    });
  }

  catCoberturaCertificados() {
    this.catCoberturaCertificadoService.catCoberturaCertificado().subscribe({
      next: (data: any) => {
        this.coberturaCertificados = data;

      }
    });
  }

  catEfectoCertificado() {
    this.catEfectoCertificadoService.catEfectoCertificado().subscribe({
      next: (data: any) => {
        this.efectosCertificados = data;

      }
    });
  }

  onChangeCoberturaCertificados(event: any) {
    this.solicitudVo.strCertificadoPor = event.target.value;

  }

  onChangeEfectoCertificado(event: any) {
    this.solicitudVo.strMotivoSolicitud = event.target.value;

  }

  documentos = [
    {
      id: '1',
      idDocumentoBack: '',
      nombreEncriptado: '',
      titulo: 'ACTA CONSTITUTIVA',
      formControlName: 'actaConstitutiva',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    },
    {
      id: '3',
      idDocumentoBack: '',
      nombreEncriptado: '',
      titulo: 'FACTURA',
      formControlName: 'factura',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    }, // Corregido ID para coincidir con formControlName
    {
      id: '5',
      idDocumentoBack: '',
      nombreEncriptado: '',
      titulo: 'INE REPRESENTANTE LEGAL',
      formControlName: 'ine',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    },
    {
      id: '6',
      idDocumentoBack: '',
      nombreEncriptado: '',
      titulo: 'PODER NOTARIAL',
      formControlName: 'poderNotarial',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    },
    {
      id: '7',
      idDocumentoBack: '',
      nombreEncriptado: '',
      titulo: 'REPUVE',
      formControlName: 'repuveDoc',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    }, // formControlName para el documento REPUVE
    {
      id: '8',
      idDocumentoBack: '',
      nombreEncriptado: '',
      titulo: 'SOLICITUD',
      formControlName: 'solicitud',
      estadoSubida: 'PENDIENTE',
      urlVisor: '',
      rawUrl: ''
    }
  ];

  //********************************** MÉTODOS PARA DOCUMENTOS *********************************************//

  onFileSelected(input: HTMLInputElement, doc: any): void {
    const nuevoArchivo = input.files?.[0];
    if (!nuevoArchivo) return;

    // --- Lógica de validación del archivo (sin cambios) ---
    if (nuevoArchivo.type !== 'application/pdf') { /* ... Swal error ... */
      return;

    }
    const maxSizeMB = 10;
    if (nuevoArchivo.size > maxSizeMB * 1024 * 1024) { /* ... Swal error ... */
      return;
    }

    const rfc = this.SegundoGrupo.get('rfcMoral')?.value;
    if (!rfc) { /* ... Swal error ... */
      return;
    }

    // ====================================================================
    // ===== INICIA LÓGICA NUEVA: ¿REEMPLAZAR O SUBIR POR PRIMERA VEZ? =====
    // ====================================================================

    if (doc.estadoSubida === 'COMPLETADO') {
      // Si ya hay un archivo, preguntamos al usuario si quiere reemplazarlo.
      Swal.fire({
        title: '¿Reemplazar archivo?',
        text: `Ya existe un archivo para "${doc.titulo}". ¿Deseas eliminar el anterior y subir el nuevo?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#41bd00',
        cancelButtonColor: '#C71128',
        confirmButtonText: 'Sí, reemplazar',
        cancelButtonText: 'No, cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          // El usuario quiere reemplazar. Primero eliminamos, luego subimos.
          this.eliminarYSubir(doc, nuevoArchivo, rfc, input);
        } else {
          // El usuario canceló, limpiamos el input para que no quede el archivo seleccionado.
          input.value = '';
        }
      });
    } else {
      // Si no hay un archivo previo, simplemente lo subimos.
      this.subirNuevoDocumento(doc, nuevoArchivo, rfc, input);
    }
  }

  /**
   * Orquesta la eliminación del archivo antiguo y luego la subida del nuevo.
   */
  private eliminarYSubir(doc: any, nuevoArchivo: File, rfc: string, input: HTMLInputElement): void {
    Swal.fire({
      title: 'Eliminando archivo anterior...',
      didOpen: () => Swal.showLoading(),
      showConfirmButton: false
    });
    this.eliminarDocumentoService.eliminarDocumentos(doc.idDocumentoBack as number, rfc, doc.nombreEncriptado)
      .pipe(
        // switchMap encadena la llamada de subida DESPUÉS de que la eliminación sea exitosa
        switchMap(() => {
          Swal.update({text: 'Subiendo nuevo archivo...'});
          return this.documentoService.subirDocumentoPdf(rfc, doc.id, nuevoArchivo);
        })
      ).subscribe({
      next: (event: HttpEvent<any>) => this.manejarEventosDeSubida(event, doc, nuevoArchivo),
      error: err => {
        this.showAlert("Error", 'No se pudo eliminar el archivo anterior. La subida del nuevo archivo ha sido cancelada.', "error")
        doc.estadoSubida = 'ERROR';
        input.value = '';
      }
    });
  }

  /**
   * Sube un documento que no tiene un predecesor a eliminar.
   */
  private subirNuevoDocumento(doc: any, nuevoArchivo: File, rfc: string, input: HTMLInputElement): void {
    doc.estadoSubida = 'CARGANDO';
    this.isUploading[doc.id] = true;
    this.uploadProgress[doc.id] = 0;
    this.documentoService.subirDocumentoPdf(rfc, doc.id, nuevoArchivo).subscribe({
      next: (event: HttpEvent<any>) => this.manejarEventosDeSubida(event, doc, nuevoArchivo),
      error: err => {
        doc.estadoSubida = 'ERROR';
        this.isUploading[doc.id] = false;
        input.value = '';
        Swal.fire('Error de Subida', `No se pudo subir el documento: ${doc.titulo}.`, 'error');
      }
    });
  }

  /**
   * Lógica centralizada para manejar los eventos de progreso y respuesta de la subida.
   */
  private manejarEventosDeSubida(event: HttpEvent<any>, doc: any, archivo: File): void {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        if (event.total) {
          this.uploadProgress[doc.id] = Math.round(100 * (event.loaded / event.total));
        }
        break;
      case HttpEventType.Response:
        this.uploadProgress[doc.id] = 100;
        doc.estadoSubida = 'COMPLETADO';
        this.isUploading[doc.id] = false;

        // Guardamos los datos importantes de la respuesta en nuestro objeto 'doc'
        doc.nombreEncriptado = event.body.identificador;
        doc.idDocumentoBack = event.body.idDocumento;

        // Actualizamos el FormGroup para que el campo sea válido
        this.SextoFormGroup.get(doc.formControlName)?.setValue(doc.idDocumentoBack);
        this.SextoFormGroup.get(doc.formControlName)?.updateValueAndValidity();

        // Generamos la vista previa
        const localUrlString = URL.createObjectURL(archivo);
        doc.rawUrl = localUrlString;
        doc.urlVisor = this.sanitizer.bypassSecurityTrustResourceUrl(localUrlString);

        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: `${doc.titulo} subido con éxito`,
          showConfirmButton: false,
          timer: 3000
        });
        break;
    }
  }


  verDocumentoEnVentana(doc: any): void {
    // Verificamos que la propiedad rawUrl (que ahora es la URL local) exista
    if (doc && doc.rawUrl) {
      window.open(doc.rawUrl, '_blank');
    } else {
      Swal.fire({
        icon: 'info',
        title: 'No disponible',
        text: 'Primero debe seleccionar un archivo para poder visualizarlo.'
      });
    }
  }

  //*********************************************-MODALES RFC Y CURP (SIN CAMBIOS)-************************************************//
  modalRFCmoral() {
    Swal.fire({
      background: 'rgb(99,32,119)',
      imageUrl: '/assets/img/imagenesCuerpo/RFCMORAL.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
          animate__animated
          animate__fadeInUp
          animate__faster
        `,
      },
      hideClass: {
        popup: `
                animate__animated
                animate__fadeOutDown
                animate__faster
              `,
      },
    });
  }

  modalRFC() {
    Swal.fire({
      background: 'rgb(99,32,119)',
      imageUrl: '/assets/img/imagenesCuerpo/RFCFISICA.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
          animate__animated
          animate__fadeInUp
          animate__faster
        `,
      },
      hideClass: {
        popup: `
                animate__animated
                animate__fadeOutDown
                animate__faster
              `,
      },
    });
  }

  modalCURP() {
    Swal.fire({
      background: 'rgb(99,32,119)',
      imageUrl: '/assets/img/imagenesCuerpo/CURP.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
          animate__animated
          animate__fadeInUp
          animate__faster
        `,
      },
      hideClass: {
        popup: `
                animate__animated
                animate__fadeOutDown
                animate__faster
              `,
      },
    });
  }

  // Méto do que "transfiere" valor automáticamente del RFC al CURP (Representante Legal)
  pasarValorRfcACurp(): void {
    const rfcControl = this.CuartoFormGroup.get('rfc');
    const curpControl = this.CuartoFormGroup.get('curp');

    if (rfcControl && curpControl) {
      const rfcValue = (rfcControl.value || '').toUpperCase();

      // Si el RFC tiene al menos 10 caracteres, copia esa parte al CURP
      if (rfcValue.length >= 10) {
        curpControl.setValue(rfcValue.substring(0, 10));
      } else {
        curpControl.setValue(rfcValue); // Si no, copia lo que haya
      }
    }
  }


  descargarDocumento() {

    // 1. Mostrar un indicador de carga
    Swal.fire({
      html: `<h4>Descargando documento <b style="color: #A11A5C">SOLICITUD DE CERTIFICADO DE NO INFRACCIÓN</b><hr>espere un momento...</h4>`,
      didOpen: () => {
        Swal.showLoading();
      },
      timer: 4000,
      timerProgressBar: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });

    // 2. Recolectar todos los datos desde tus formularios
    // NOTA: Asegúrate de que los nombres de los formControlName coincidan
//    const nombreCompleto = `${this.CuartoFormGroup.get('nombre')?.value}  ${this.QuintoFormGroup.get('apellidoPaterno')?.value} ${this.QuintoFormGroup.get('apellidoMaterno')?.value}`;
    const nombre = this.CuartoFormGroup.get('nombre')?.value || '';
    const paterno = this.CuartoFormGroup.get('apellidoPaterno')?.value || '';
    const materno = this.CuartoFormGroup.get('apellidoMaterno')?.value || '';

    const nombreCompleto = `${nombre} ${paterno} ${materno}`.trim();

    const rfc = this.SegundoGrupo.get('rfcMoral')?.value;
    const rfcReprecentante = this.CuartoFormGroup.get('rfc')?.value;
    const razonSocial = this.SegundoGrupo.get('razonSocial')?.value;
    const curp = this.CuartoFormGroup.get('curp')?.value; // O el que corresponda
    const domicilio = `${this.SegundoGrupo.get('calle')?.value} ${this.TercerFormGroup.get('numExterior')?.value || ''}`;
    const municipio = this.SegundoGrupo.get('municipio')?.value;
    const estado = this.SegundoGrupo.get('estado')?.value;

    const certificadoId = this.PrimerFormGroup.get('certificadoPor')?.value;
    const certificadoSeleccionado = this.coberturaCertificados.find(
      certificado => certificado.id_cobertura_certificado == certificadoId
    );
    const garantias = certificadoSeleccionado ? certificadoSeleccionado.certificado_por : '';

    const niv = this.PrimerFormGroup.get('niv')?.value;
    const placa = this.PrimerFormGroup.get('placa')?.value;
    const marca = this.PrimerFormGroup.get('marca')?.value;
    const estadoVehiculo = 'Tlaxcala'

    const modelo = this.PrimerFormGroup.get('modelo')?.value;
    const refrendo = this.PrimerFormGroup.get('refrendo')?.value;
    let tipoServicio: string;
    if (this.PrimerFormGroup.get('tipoServicio')?.value === '1') {
      tipoServicio = "PÚBLICO";
    } else {
      tipoServicio = "PRIVADO";
    }
    const motor = this.PrimerFormGroup.get('motor')?.value;
    const repuve = this.PrimerFormGroup.get('repuve')?.value;
    const tipoPersona = 'M';

    // 3. Llamar al servicio con todos los datos recolectados
    this.imprimirSolicitudService.imprimirSolicitudCdniGenerico(
      nombreCompleto, rfc, rfcReprecentante, razonSocial, curp, domicilio, municipio, estado, garantias, niv,
      placa, marca, estadoVehiculo, modelo, refrendo, tipoServicio, motor, repuve, tipoPersona
    ).subscribe({
      next: (data: Blob) => {
        // 4. Lógica para procesar la respuesta y descargar el archivo
        Swal.close(); // Cerrar el indicador de carga
        const blob = new Blob([data], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);

        // Crear un enlace temporal para iniciar la descarga
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Solicitud_No_Infraccion.pdf'; // Nombre del archivo

        // Simular clic en el enlace y luego removerlo
        link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

        // Limpiar la URL del objeto creado para liberar memoria
        window.URL.revokeObjectURL(url);
        link.remove();
      },
      error: (error) => {

        Swal.fire({
          icon: 'error',
          title: 'Error en la descarga',
          text: 'No se pudo generar el documento. Por favor, inténtelo de nuevo más tarde.'
        });
      }
    });
  }


} // Fin de la clase PersonaMoralEstatalComponent


// Función Helper fuera de la clase
function transformarRespuestaVehiculo(data: EstatusVehiculoResponseMoral): any {
  if (!data) return {};

  const vehiculo = data.datosVehiculoResponseVo || {};
  const personaMoral = data.datosPersonaResponseVo || {};
  const domicilio = data.datosDomicilioResponseVo || {};
  const errores = data.vehiculoErrorResponseVo || {};

  return {
    // PrimerFormGroup (Datos del Vehículo)
    categoria: vehiculo.strCategoria || '',
    marca: vehiculo.strMarca || '',
    submarca: vehiculo.strSubMarca || '',
    modelo: vehiculo.strModelo || '',
    motor: vehiculo.strMotor || '',
    refrendo: vehiculo.strRefrendo || '',
    repuve: vehiculo.strRepuve || '',

    // SegundoGrupo (Datos de la Empresa y Domicilio Fiscal)
    rfcMoral: personaMoral.strRfc || '',
    fechaConstitucion: personaMoral.strFechaConstitucion || '',
    razonSocial: personaMoral.strRazonSocial || '',

    calle: domicilio.strCalle || '',
    numExterior: domicilio.strNoExterior || '',
    numInterior: domicilio.strNoInterior || '',
    codigoPostal: domicilio.strCodigoPostal || '',
    estado: domicilio.strEstado || '',
    municipio: domicilio.strMunicipio || '',
    localidad: domicilio.strLocalidad || '',

    // Opcional: TercerFormGroup (Flags de validación del vehículo)
    tieneInfraccion: errores.tieneInfraccion ?? false,
    tieneFotoMulta: errores.tieneFotoMulta ?? false,
    tieneReporteRobo: errores.tieneReporteRobo ?? false,
    mensajeErrorVehiculo: errores.strMensaje || '',

    // Representante Legal: NO viene en esta respuesta, se llena manualmente por el usuario.
  };
}


function inferirFechaConstitucion(rfc: string): string | null {
  // 1. Validar que el RFC sea una cadena y tenga 12 caracteres.
  if (typeof rfc !== 'string' || rfc.length !== 12) {
    console.error();
    return null;
  }

  try {
    // 2. Extraer la subcadena YYMMDD (posiciones 3 a 8).
    const fechaSubstr = rfc.substring(3, 9);

    // 3. Separar las partes de la fecha.
    const anioDosDigitos = parseInt(fechaSubstr.substring(0, 2), 10);
    const mes = fechaSubstr.substring(2, 4);
    const dia = fechaSubstr.substring(4, 6);

    // 4. Determinar el siglo.
    const anioActualDosDigitos = new Date().getFullYear() % 100;
    const siglo = (anioDosDigitos > anioActualDosDigitos) ? '19' : '20';

    // 5. Formatear la fecha final en YYYY-MM-DD.
    const anioCompleto = siglo + anioDosDigitos.toString().padStart(2, '0');

    const fechaFormateada = `${anioCompleto}-${mes}-${dia}`;

    // Opcional: Validar que la fecha construida sea una fecha real.
    const fechaObjeto = new Date(fechaFormateada);
    if (isNaN(fechaObjeto.getTime())) {
      console.error();
      return null;
    }

    return fechaFormateada;

  } catch (error) {
    console.error(error);
    return null;
  }
}

function inferirDatosDesdeCurp(curp: string): { sexo: string, fechaNacimiento: string } | null {
  // 1. Validar que la CURP sea una cadena y tenga 18 caracteres.
  if (typeof curp !== 'string' || curp.length !== 18) {
    console.error();
    return null;
  }

  try {
    // 2. Extraer las partes de la fecha (YYMMDD) y el sexo.
    const fechaSubstr = curp.substring(4, 10);
    const sexoChar = curp.charAt(10).toUpperCase();

    // 3. Inferir el siglo para el año de nacimiento
    const anioDosDigitos = parseInt(fechaSubstr.substring(0, 2), 10);
    const diferenciadorSiglo = curp.charAt(16);
    // Si el caracter en la posición 17 es una letra, es del año 2000 en adelante.
    const siglo = isNaN(parseInt(diferenciadorSiglo)) ? '20' : '19';
    const anioCompleto = siglo + anioDosDigitos.toString().padStart(2, '0');

    // 4. Formatear la fecha a DD-MM-AAAA como solicitaste
    const mes = fechaSubstr.substring(2, 4);
    const dia = fechaSubstr.substring(4, 6);
    const fechaFormateada = `${dia}-${mes}-${anioCompleto}`;

    // 5. Determinar el sexo
    const sexo = sexoChar === 'H' ? 'MASCULINO' : 'FEMENINO';

    // 6. Validar que la fecha construida sea real
    const fechaObjeto = new Date(`${anioCompleto}-${mes}-${dia}`);
    if (isNaN(fechaObjeto.getTime())) {

      return null;
    }

    return {
      sexo: sexo,
      fechaNacimiento: fechaFormateada
    };

  } catch (error) {

    return null;
  }
}